"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Documents = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _Document = require("../Document");
var _DocumentGroup = require("../DocumentGroup");
var styles = _interopRequireWildcard(require("./Documents.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Documents = _ref => {
  let {
    documents,
    documentsCount,
    documentsCountHasWarning
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['documents']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043A\u043E\u0440\u043F\u0443\u0441\u0430"), /*#__PURE__*/React.createElement("div", {
    className: styles['subtitle']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: documentsCountHasWarning ? 'warning_100' : 'gray40_100'
  }, documentsCount))), documents.map(document => {
    if (document.type === 'pdf') {
      return /*#__PURE__*/React.createElement(_Document.Document, {
        key: document.url,
        title: document.title,
        subtitle: document.subtitle,
        link: document.url,
        isActual: document.isActual
      });
    }
    if (document.type === 'set' && document.subdocuments) {
      return /*#__PURE__*/React.createElement(_DocumentGroup.DocumentGroupToggle, {
        key: document.title,
        title: document.title,
        documents: document.subdocuments.map(subdocument => /*#__PURE__*/React.createElement(_Document.Document, {
          key: subdocument.url,
          title: subdocument.title,
          link: subdocument.url
        }))
      });
    }
    return null;
  }));
};
exports.Documents = Documents;